export default "<p>oficina-main works!</p>\n"